import React, {useEffect, useState} from 'react';
import {ConfirmDialog} from "primereact/confirmdialog";
import {Dialog} from "primereact/dialog";
import {Button} from "primereact/button";
import {confirmPopup} from "primereact/confirmpopup";
import { OrderList } from 'primereact/orderlist'
import Form from "../../Pages/Form";
import {v4 as uuid} from 'uuid';
import {Toolbar} from "primereact/toolbar";
import {getItemNames, recordFieldByLocation, toIcon, toStyle, wrapArray} from "../utils";
import _ from 'lodash';
import parseCss from 'style-to-js';

import {getDisplayFields, getSearchFields} from "../AirtableFields/RecordLinks/search.common";
import {Tooltip} from "primereact/tooltip";
type CreateNewFormProps = {
    form_id: number
    details: any
    control: OpenControls
    extraConfig: any
    onSave?: (data:any) => void
}
export const CreateNewForm = ({form_id, onSave, control, details, extraConfig}:CreateNewFormProps) => {
    const [recId] = useState(uuid())
    const formRef = React.useRef(null)
    const {singular, plural} = getItemNames(extraConfig,'Linked Record')
    const onHide = (e=null) => {
        if(e)e.preventDefault()
        control.handleClose()
    }
    const onAccept = (e) => {
        if(formRef.current){
            formRef.current?.validateForm().then( errors => {
                if(_.isEmpty(errors)){
                    onHide(e)
                    onSave( recId )
                }else{
                    formRef.current?.setTouched(_.reduce( errors, (out, val,key) => { out[key] = true; return out;}, {}))
                }
            })
        }
    }

    useEffect( () => {
        console.log("FORM IS VALID?",formRef.current?.isValid)

    }, [formRef.current?.isValid])


    return <Dialog visible={control.isVisible} closable={false} onHide={onHide} header={`Create New ${singular}`}
                          breakpoints={{'960px': '75vw', '640px': '100vw'}} style={{width: '60vw'}}
                          draggable={false} footer={(
        <div>
            <Button label="Cancel" icon="pi pi-times" className={'p-button-secondary'} onClick={onHide} />
            <Button label="Add" icon="pi pi-check" onClick={onAccept} />
        </div>
    )}>
        <Form key={recId} mode={details.mode} form_id={form_id} record_id={recId} path={details.path} formRef={formRef}/>
    </Dialog>
}

export const controlsVisible = (canBeVisible, visibility, mode = 'main'):any => {
    const newVis = {}

    _.each(canBeVisible, (val,key) => {
        newVis[key] = val && (_.get(visibility, `permissions.main.allow_${key}`))
    })
    console.log('ControlsVisible', canBeVisible, visibility, newVis)
    return newVis
}

export const renderControlButtons = (visibility, onFuncs, options:any = {}) => {
    const btnStyle = {marginRight: '0.5rem', marginBottom: '0.5rem', }
    console.log('Rendering Control Buttons', options)
    const full = options.full_width ? 'w-full' : ''
    const id = `disabled-control-button-${uuid()}`
    const map = [
        { key: 'cancel', label: 'Cancel', icon: 'undo', click: onFuncs.onCancel , class: '' },
        { key: 'lookup', label: 'Find Existing', icon: 'search', click: onFuncs.onLookup, class: 'p-button-info'  },
        { key: 'create', label: 'Create New', icon: 'plus', click: onFuncs.onCreate, class: 'p-button-success'  },
        { key: 'edit', label: 'Edit', icon: 'pencil', click: onFuncs.onEdit, class: ''  },
        { key: 'display', label: 'View', icon: 'eye', click: onFuncs.onDisplay, class: ''  },
        { key: 'order', label: 'Order List', icon: 'sort-alt', click: onFuncs.onOrder, class: 'p-button-secondary'  },
        { key: 'remove', label: 'Remove', icon: 'times', class: 'p-button-danger', click: (e) => {
                return _.get(options,'custom.remove.confirm', true) ? confirmPopup({
                    target: e.currentTarget,
                    message: 'Are you sure you want to remove this?',
                    icon: 'pi pi-exclamation-triangle',
                    accept: onFuncs.onRemove
                }) : onFuncs.onRemove ? onFuncs.onRemove(e) : null
            }  },
    ]
    const get = (item, path, def='') => {
        const val = _.get(options, `${path}.${item.key}`, def)
        const isDisabled = _.get(options, `disabled.${item.key}`)
        if(isDisabled){
            return _.get(options,`${path}.${item.key}_disabled`, val)
        }
        return val
    }
    return (
        <><Tooltip target={`.${id}`} />
        <div className={`flex flex-wrap md:flex-nowrap ${options.classes?.grouping || ''}`} style={{width: '100%', ...(toStyle(options.styles?.grouping))}}>
            {map.map( item => (
                <>{visibility[item.key] && <div data-pr-tooltip={get(item, 'tooltip') } data-pr-position={get(item,'tooltip.placement', 'bottom')} className={`${id} flex ${full}`}><Button style={{...btnStyle, ...(toStyle(get(item,'styles')))}} icon={toIcon(get(item, 'icons', item.icon))} className={`${id} ${item.class} flex p-button-outline p-button-raised ${get(item, 'classes')}`} label={get(item, 'labels', item.label)} onClick={item.click} disabled={get(item, 'disabled')} /></div>}</>
            ))}

        </div>
        </>

    )
}

export const orderRecords = ( items: any[], control: OpenControls, config:any, onDone: (ordered:any) => void ) => {
    const [ordered,setOrdered] = useState(null)

    useEffect( () => {
        if(items){
            console.log('**Setting Sorted Records**', {items})
            setOrdered(wrapArray(items))
        }
    }, [wrapArray(items).map(i => i?.tableRecordId).join('')])

    const onHide = () => {
        control.handleClose()
        setOrdered(null)
    }
    const onDoneClick = (e) => {
        e.preventDefault()
        onHide()
        onDone(ordered)

    }
    if(!control?.isVisible) return <></>

    const primary = recordFieldByLocation('primary', config)
    const {singular, plural} = getItemNames(config,'Linked Record')
    const orderLabel = _.get(config,'controls.options.labels.order',`Order ${plural}`)
    const itemTemplate = (rec) => {
        return <p>{rec[primary?.name]}</p>
    }

    return <Dialog visible={control.isVisible} breakpoints={{'960px': '75vw', '640px': '100vw'}} style={{width: '50vw'}}
                   header={orderLabel} onHide={onHide} closable={true} position={'center'} footer={<Button onClick={onDoneClick} label={'DONE'}/>}>
            <OrderList dragdrop={true} value={ordered} itemTemplate={itemTemplate} header={plural} onChange={(e) => setOrdered(e.value)}/>
        </Dialog>
}
